<template>
  <div class="publish-agent">
    <!-- 侧边栏与主内容区 -->
    <div class="flex max-w-7xl mx-auto px-4 py-8">
      <!-- 侧边栏 -->
      <aside class="w-56 mr-8 hidden md:block">
        <nav class="space-y-2">
          <a 
            v-for="(section, index) in sections" 
            :key="index"
            :href="`#${section.id}`"
            :class="[
              'block px-4 py-2 rounded-lg',
              activeSection === section.id 
                ? 'bg-pink-50 text-pink-700 font-bold' 
                : 'hover:bg-pink-50'
            ]"
            @click.prevent="scrollToSection(section.id)"
          >
            {{ $store.getters.t(section.label) }}
          </a>
        </nav>
      </aside>
      
      <!-- 主内容区 -->
      <main class="flex-1 space-y-8">
        <!-- 素材库/模板/设计 -->
        <section id="material" class="bg-white rounded-lg shadow-md p-6 card-hover">
          <div class="flex justify-between items-center mb-4">
            <h2 class="text-xl font-bold flex items-center">
              <i class="fas fa-photo-video text-pink-600 mr-2"></i>
              {{ $store.getters.t('material') }}
            </h2>
            <button class="bg-pink-600 text-white px-4 py-2 rounded-lg hover:bg-pink-700">
              <i class="fas fa-plus mr-2"></i>
              {{ $store.getters.t('add_material') }}
            </button>
          </div>
          <p class="text-gray-600 mb-4">{{ $store.getters.t('material_desc') }}</p>
          <button class="bg-pink-100 text-pink-700 px-3 py-1 rounded-lg text-sm font-bold hover:bg-pink-200">
            <i class="fas fa-magic mr-1"></i>
            {{ $store.getters.t('ai_material') }}
          </button>
        </section>
        
        <!-- 分割短片/字幕/翻译 -->
        <section id="clip" class="bg-white rounded-lg shadow-md p-6 card-hover">
          <div class="flex justify-between items-center mb-4">
            <h2 class="text-xl font-bold flex items-center">
              <i class="fas fa-cut text-blue-600 mr-2"></i>
              {{ $store.getters.t('clip') }}
            </h2>
            <button class="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700">
              <i class="fas fa-scissors mr-2"></i>
              {{ $store.getters.t('add_clip') }}
            </button>
          </div>
          <p class="text-gray-600 mb-4">{{ $store.getters.t('clip_desc') }}</p>
          <button class="bg-blue-100 text-blue-700 px-3 py-1 rounded-lg text-sm font-bold hover:bg-blue-200">
            <i class="fas fa-magic mr-1"></i>
            {{ $store.getters.t('ai_clip') }}
          </button>
        </section>
        
        <!-- 多平台发布 -->
        <section id="publish" class="bg-white rounded-lg shadow-md p-6 card-hover">
          <div class="flex justify-between items-center mb-4">
            <h2 class="text-xl font-bold flex items-center">
              <i class="fas fa-share-square text-green-600 mr-2"></i>
              {{ $store.getters.t('publish') }}
            </h2>
            <button class="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700">
              <i class="fas fa-share mr-2"></i>
              {{ $store.getters.t('add_publish') }}
            </button>
          </div>
          <p class="text-gray-600 mb-4">{{ $store.getters.t('publish_desc') }}</p>
          <button class="bg-green-100 text-green-700 px-3 py-1 rounded-lg text-sm font-bold hover:bg-green-200">
            <i class="fas fa-magic mr-1"></i>
            {{ $store.getters.t('ai_publish') }}
          </button>
        </section>
      </main>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PublishAgent',
  data() {
    return {
      activeSection: 'material',
      sections: [
        { id: 'material', label: 'material' },
        { id: 'clip', label: 'clip' },
        { id: 'publish', label: 'publish' }
      ]
    }
  },
  methods: {
    scrollToSection(sectionId) {
      this.activeSection = sectionId
      const element = document.getElementById(sectionId)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    },
    handleScroll() {
      const sections = this.sections
      const scrollPosition = window.scrollY + 100

      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i].id)
        if (section && section.offsetTop <= scrollPosition) {
          this.activeSection = sections[i].id
          break
        }
      }
    }
  },
  mounted() {
    // 监听滚动事件，更新活动区域
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style scoped>
.publish-agent {
  background: #f5f5f5;
  min-height: calc(100vh - 64px);
}

.card-hover {
  transition: all 0.3s ease;
}

.card-hover:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.1);
}

.space-y-8 > * + * {
  margin-top: 2rem;
}

.mb-4 {
  margin-bottom: 1rem;
}

.mr-2 {
  margin-right: 0.5rem;
}

.mr-1 {
  margin-right: 0.25rem;
}

.text-xl {
  font-size: 1.25rem;
}

.font-bold {
  font-weight: 700;
}

.text-gray-600 {
  color: #4b5563;
}

.text-pink-600 {
  color: #db2777;
}

.text-blue-600 {
  color: #2563eb;
}

.text-green-600 {
  color: #16a34a;
}

.bg-pink-600 {
  background-color: #db2777;
}

.bg-blue-600 {
  background-color: #2563eb;
}

.bg-green-600 {
  background-color: #16a34a;
}

.hover\:bg-pink-700:hover {
  background-color: #be185d;
}

.hover\:bg-blue-700:hover {
  background-color: #1d4ed8;
}

.hover\:bg-green-700:hover {
  background-color: #15803d;
}

.text-white {
  color: #ffffff;
}

.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.rounded-lg {
  border-radius: 0.5rem;
}

.text-sm {
  font-size: 0.875rem;
}

.bg-pink-100 {
  background-color: #fce7f3;
}

.bg-blue-100 {
  background-color: #dbeafe;
}

.bg-green-100 {
  background-color: #dcfce7;
}

.text-pink-700 {
  color: #be185d;
}

.text-blue-700 {
  color: #1d4ed8;
}

.text-green-700 {
  color: #15803d;
}

.hover\:bg-pink-200:hover {
  background-color: #fbcfe8;
}

.hover\:bg-blue-200:hover {
  background-color: #bfdbfe;
}

.hover\:bg-green-200:hover {
  background-color: #bbf7d0;
}

.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.bg-pink-50 {
  background-color: #fdf2f8;
}

.hover\:bg-pink-50:hover {
  background-color: #fdf2f8;
}

.text-pink-700 {
  color: #be185d;
}

.space-y-2 > * + * {
  margin-top: 0.5rem;
}

.w-56 {
  width: 14rem;
}

.mr-8 {
  margin-right: 2rem;
}

.hidden {
  display: none;
}

@media (min-width: 768px) {
  .md\:block {
    display: block;
  }
}

.flex-1 {
  flex: 1 1 0%;
}
</style> 